import { Box, styled } from "@mui/material";
import { colors } from '../../../../theme/colors';

export const MainWrapper = styled(Box)({
  "& .btn": {
    textTransform: "capitalize",
    backgroundColor: colors.primary,
    color: "#fff",
    borderRadius: "8px",
    padding: "8px 20px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      boxShadow: `0 4px 12px ${colors.primary}44`,
    },
    "& .MuiCircularProgress-root": {
      marginLeft: "8px",
    },
  },

  "& .btn.Mui-disabled": {
    backgroundColor: colors.buttonDisabled.background,
    color: colors.buttonDisabled.color,
    opacity: 1,
    cursor: "not-allowed",
  },
  "& .MuiTableBody-root .MuiTableRow-root": {
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: colors.sidebarHover,
    },
  },
  "& table": {
    minWidth: "900px",
  },
  "& .custom-scrollbar": {
    marginBottom: "20px",
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "lightgray",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: colors.primary,
      borderRadius: "10px",
      border: "2px solid lightgray",
    },
  },
  "& .table-container": {
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  "& .MuiTableCell-head": {
    color: "#fff !important",
    fontSize: "13.5px",
    fontWeight: 600,
    backgroundColor: colors.primary,
    backgroundImage: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    padding: "14px 16px",
  },

  "& .required_field": {
    minWidth: "300px",
  },
  "& .role-dropdown": {
    minWidth: "300px",
  },
  "& .question-input-wrapper": {
    marginTop: "16px",
    padding: "16px 20px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    border: "1px solid rgba(145, 158, 171, 0.24)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
  },
  "& .submit-button-container": {
    marginTop: "32px",
    display: "flex",
    justifyContent: "flex-end",
  },
  "& .submit-btn": {
    minWidth: "120px",
  },
  "& .role-menu-item": {
    "&:hover": {
      color: `${colors.primary} !important`,
    },
    "&.Mui-focused:hover": {
      color: `${colors.primary} !important`,
    },
  },
  "& .action-buttons-container": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.4rem",
  },
  "& .edit-button": {
    color: colors.primary,
    border: `1px solid ${colors.primaryLightBorder}`,
    borderRadius: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primary,
      color: "#fff",
      borderColor: colors.primary,
    },
    "&.Mui-disabled": {
      border: "1px solid #e5e7eb",
      opacity: 0.5,
    },
  },
  "& .delete-button": {
    color: "#dc2626",
    border: "1px solid #fca5a5",
    borderRadius: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#dc2626",
      color: "#fff",
      borderColor: "#dc2626",
    },
    "&.Mui-disabled": {
      border: "1px solid #e5e7eb",
      opacity: 0.5,
    },
  },
  "& .icon-large": {
    fontSize: "large",
  },
  "& .pagination-container": {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  "& .rows-per-page-select": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(145, 158, 171, 0.5)",
      borderRadius: "10px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(145, 158, 171, 0.85)",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.primary,
      borderWidth: "2px",
    },
  },
  "& .rows-per-page-label": {
    "&.Mui-focused": {
      color: colors.primary,
    },
  },
  "& .cancel-btn": {
    borderColor: colors.primary,
    color: colors.primary,
    textTransform: "capitalize",
    "&:hover": {
      borderColor: colors.primary,
      backgroundColor: "rgba(127, 29, 29, 0.04)",
    },
  },
});
